// extracted by mini-css-extract-plugin
export default {"box":"styles_box__b0wGh","content":"styles_content__4zxUH","title":"styles_title__bFCV8","bold_txt":"styles_bold_txt__PRVRg"};